export const BACKOFFICE_ACCESS = "backoffice_access";
export const CALL_CENTER_LIGHT_USER = "callcenter_light_user";
export const CALL_CENTER_USER = "callcenter";
